import { get, ref, set } from "firebase/database";
import { db } from "./Firebase";

async function getCaseData(caseNumber) {
  const caseRef = ref(db, `cases/${caseNumber}`);
  const snapshot = await get(caseRef);

  if (snapshot.exists()) {
    return snapshot.val();
  } else {
    throw new Error("Case not found");
  }
}

async function addCaseData(caseData) {
  const caseRef = ref(db, `cases/${caseData.caseNumber}`);
  await set(caseRef, caseData);
}

export { addCaseData, getCaseData };
